import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const TransactionContainer = styled.div``;

export const BodyLoader = styled(ContentLoader)`
  height: 6.8rem;
  width: 100%;
`;

export const AssetIcons = styled.circle`
  r: 1.7rem;
  cx: 2.7rem;
  cy: 3.4rem;

  ${({ theme }) => theme.media.mobileL`
      cx: 3.8rem;
  `};

  ${({ theme }) => theme.media.laptop`
      cx: 4.1rem;
  `};
`;

export const Status = styled.rect`
  height: 1.8rem;
  width: 7rem;

  x: 5.4rem;
  y: 1.4rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.mobileL`
      x: 6.5rem;
  `};

  ${({ theme }) => theme.media.laptop`
    x: 6.8rem;
  `};
`;

export const AssetCode = styled.rect`
  height: 1.6rem;
  width: 8rem;

  x: 5.4rem;
  y: 3.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.mobileL`
      x: 6.5rem;
  `};

  ${({ theme }) => theme.media.laptop`
    x: 6.8rem;
  `};
`;

export const Amount = styled.rect`
  /* display: none; */

  height: 1.8rem;
  width: 9rem;

  x: 73%;
  y: 2.3rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop`
    x: 80%;
    y: 2.3rem;
  `};
`;

export const AmountSecond = styled.rect`
  height: 1rem;
  width: 5rem;

  x: 82%;
  y: 4.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop`
    x: 86%;
    y: 4.5rem;
  `};
`;
